import "./ScheduleYourStrategySession.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AiStudyAssistantInput from "./sections/AiStudyAssistantInput";
import WhyChooseUs from "./sections/WhyChooseUs";
import Footer from "@/reusable_sections/Footer";
export default function ScheduleYourStrategySessionPage() {
  return <div>
      <Header />
      <Hero />
      <AiStudyAssistantInput />
      <WhyChooseUs />
      <Footer />
    </div>;
}